import * as actions from 'appRedux/actions/taxInvoice/settingsActionType';

export interface TaxInvoiceSettingsState {
  loader: boolean;
  data: {
    settings: {
      ISSUE_TAX?: boolean;
      FORCE_ISSUE_TAX: boolean;
      BOOK_CREDIT_NOTE: string;
      BOOK_TAX_INVOICE: string;
      BOOK_CREDIT_NOTE_MANUAL: string;
      BOOK_TAX_INVOICE_MANUAL: string;
      VAT_ITEM_DESCRIPTION: string;
      ALLOW_MANUAL_ISSUE?: boolean;
    };
    enabled: boolean;
  } | null;
  error: string | null;
  process: {
    status: boolean;
    action: string;
    message: string;
  };
}

const initialState: TaxInvoiceSettingsState = {
  loader: false,
  data: null,
  error: null,
  process: {
    status: false,
    action: '',
    message: '',
  },
};

export default (
  state: TaxInvoiceSettingsState = initialState,
  action: actions.TaxInvoiceSettingsAction
): TaxInvoiceSettingsState => {
  switch (action.type) {
    case actions.TAX_INVOICE_SETTINGS_REQUEST:
      return {
        ...state,
        loader: true,
        error: null,
        process: {
          status: false,
          action: 'taxInvoiceSettingsRequest',
          message: '',
        },
      };

    case actions.TAX_INVOICE_SETTINGS_SUCCESS: {
      const response = action.payload;
      const settingsData = response.data?.result_data || null;

      return {
        ...state,
        loader: false,
        data: settingsData,
        error: null,
        process: {
          status: true,
          action: 'taxInvoiceSettingsRequest',
          message: response.data?.result_msg || 'Success',
        },
      };
    }

    case actions.TAX_INVOICE_SETTINGS_ERROR:
      return {
        ...state,
        loader: false,
        error: action.payload.message,
        process: {
          status: false,
          action: 'taxInvoiceSettingsRequest',
          message: action.payload.message,
        },
      };

    case actions.TAX_INVOICE_SETTINGS_RESET:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

